// Components
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import LoadingWrapper from 'components/LoadingWrapper';
// Utils
import { getText } from 'i18n/intl';
import { useAppDispatch } from 'slices/store';
// Slices
import {
  discardChange,
  fetchSupportInfo,
  setsUpdatedSupportInfo,
  supportInfoLoading,
  updateSupportInfo,
  updatedSupportInfoSelector,
} from 'slices/supportInfo.slice';
import { Button, DefaultContentLayout, TEInput } from '@timeedit/ui-components';
import { Typography } from '@timeedit/ui-components/antd';
// Styles
import './index.scss';

const SupportInfoPage = () => {
  const dispatch = useAppDispatch();
  const supportInfo = useSelector(updatedSupportInfoSelector);
  const loading = useSelector(supportInfoLoading);

  useEffect(() => {
    dispatch(fetchSupportInfo());
  }, []);

  const handleChange = (key: string, value: string) => {
    dispatch(
      setsUpdatedSupportInfo({
        ...supportInfo,
        [key]: value,
      })
    );
  };

  return (
    <DefaultContentLayout
      title={getText('support_info')}
      subtitle={getText('support_info_subtitle')}
      actions={
        <>
          <Button
            onClick={() => {
              dispatch(discardChange());
            }}
          >
            {getText('discard_changes')}
          </Button>
          <Button
            type="primary"
            onClick={() => {
              dispatch(updateSupportInfo(supportInfo));
            }}
          >
            {getText('save_changes')}
          </Button>
        </>
      }
    >
      <LoadingWrapper isLoading={loading}>
        <div className="support-info">
          <div className="content">
            <Typography.Title level={4}>General support info</Typography.Title>
            <TEInput.Input
              label="Name"
              tooltip="Name"
              value={supportInfo.generalName}
              onChange={(val) => handleChange('generalName', val)}
            />
            <TEInput.Input
              label="Email"
              tooltip="Email"
              value={supportInfo.generalEmail}
              onChange={(val) => handleChange('generalEmail', val)}
            />
            <TEInput.Input
              label="Phone"
              tooltip="Phone"
              value={supportInfo.generalPhone}
              onChange={(val) => handleChange('generalPhone', val)}
            />
            <TEInput.Input
              label="URL"
              tooltip="URL"
              value={supportInfo.generalUrl}
              onChange={(val) => handleChange('generalUrl', val)}
            />
            <TEInput.Input
              label="URL title"
              tooltip="URL title"
              value={supportInfo.generalUrlTitle}
              onChange={(val) => handleChange('generalUrlTitle', val)}
            />
            <TEInput.Input
              label="Manual"
              tooltip="Manual"
              value={supportInfo.generalManualUrl}
              onChange={(val) => handleChange('generalManualUrl', val)}
            />
            <TEInput.Input
              label="Manual title"
              tooltip="Manual title"
              value={supportInfo.generalManualUrlTitle}
              onChange={(val) => handleChange('generalManualUrlTitle', val)}
            />
            <TEInput.TextArea
              label="Description"
              tooltip="Description"
              flow="column"
              rows={5}
              value={supportInfo.generalDescription}
              onChange={(val) => handleChange('generalDescription', val)}
            />
            <br />
            <Typography.Title level={4}>
              Technical support info
            </Typography.Title>
            <TEInput.Input
              label="Name"
              tooltip="Name"
              value={supportInfo.technicalName}
              onChange={(val) => handleChange('technicalName', val)}
            />
            <TEInput.Input
              label="Email"
              tooltip="Email"
              value={supportInfo.technicalEmail}
              onChange={(val) => handleChange('technicalEmail', val)}
            />
            <TEInput.Input
              label="Phone"
              tooltip="Phone"
              value={supportInfo.technicalPhone}
              onChange={(val) => handleChange('technicalPhone', val)}
            />
            <TEInput.Input
              label="URL"
              tooltip="URL"
              value={supportInfo.technicalUrl}
              onChange={(val) => handleChange('technicalUrl', val)}
            />
            <TEInput.Input
              label="URL title"
              tooltip="URL title"
              value={supportInfo.technicalUrlTitle}
              onChange={(val) => handleChange('technicalUrlTitle', val)}
            />
            <TEInput.Input
              label="Manual"
              tooltip="Manual"
              value={supportInfo.technicalManualUrl}
              onChange={(val) => handleChange('technicalManualUrl', val)}
            />
            <TEInput.Input
              label="Manual title"
              tooltip="Manual title"
              value={supportInfo.technicalManualUrlTitle}
              onChange={(val) => handleChange('technicalManualUrlTitle', val)}
            />
            <TEInput.TextArea
              label="Description"
              tooltip="Description"
              flow="column"
              rows={5}
              value={supportInfo.technicalDescription}
              onChange={(val) => handleChange('technicalDescription', val)}
            />
          </div>
        </div>
      </LoadingWrapper>
    </DefaultContentLayout>
  );
};

export default SupportInfoPage;
